$(document).ready(function () {
  require(['mojo/signup-forms/Loader'], function (L) {
    L.start({
      baseUrl: 'mc.us8.list-manage.com',
      uuid: '34427879ce889cb69ae1b9e75',
      lid: '7e58348ec9',
    });
  });
});
